import z from "zod";
import { optionalNumber, optionalText, requiredDate, requiredId, requiredText } from "../lib/schemas";
import { ComplianceStatus } from "../types/status.types";
//Para Get O Delete por el Id que se pasa por Param
export const complianceIdParamSchema = z.object({
    complianceId: requiredId,
});
//Respuesta del GET de un cumplimiento por Id
export const getComplianceOutputSchema = z.object({
    id: requiredId,
    document: requiredText,
    provider: requiredText,
    issuedAt: optionalText,
    expireAt: optionalNumber,
    status: z.enum(ComplianceStatus),
});
export const updateComplianceInputSchema = z.object({
    issuedAt: requiredDate,
});
